// export const SET_BREAKDOWNDETECTEDDIALOGOPEN = 'SET_BREAKDOWNDETECTEDDIALOGOPEN';
export const SET_STOPPEDLINE = 'SET_STOPPEDLINE';
export const SET_HELPFILESDIALOGOPEN = 'SET_HELPFILESDIALOGOPEN';
export const SET_SCALEDATA = 'SET_SCALEDATA';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const SET_SYSTEMPARAMETERS = 'SET_SYSTEMPARAMETERS';

